import './PsychiatristDetail.less'
import { useSearchParams } from 'react-router-dom'
import { _getPsychologicalDetail } from '@/api/user'
import { useEffect, useState } from 'react';
import { htmlDecode } from '@/utils/tool';

const PsychiatristDetail = () => {
  const [ params ] = useSearchParams()
  const id = params.getAll('id')[0]

  const [detail, setDetail] = useState({
    id: '',
    address: '',
    content: '',
    name: '',
    submitDate: '',
  })

  const getDetail = () => {
    _getPsychologicalDetail({ id }).then(res => {
      const [ d, result ] = res
      if (d && result) {
        setDetail({
          ...result,
          content: htmlDecode(result.content)
        })
      }
    })
  }

  useEffect(() => {
    getDetail()
  }, [])

  return (
    <div className='pg-psychiatrist-detail'>
      <div className='pg-psychiatrist-detail--container'>
        <div className='header'>
          <div className='item'>
            <div>
              <div className='label'>咨询人</div>
              <div>{ detail.name }</div>
            </div>
          </div>
          <div className='item'>
            <div className='label'>提交时间</div>
            <div>{ detail.submitDate }</div>
          </div>
        </div>
        <div className='content'>
          <div className='title'>咨询内容</div>
          <div>{ detail.content }</div>
        </div>
      </div>
    </div>
  )
}

export default PsychiatristDetail